import { render, staticRenderFns } from "./submitOrder.vue?vue&type=template&id=5809488b&scoped=true&"
import script from "./submitOrder.vue?vue&type=script&lang=js&"
export * from "./submitOrder.vue?vue&type=script&lang=js&"
import style0 from "./submitOrder.vue?vue&type=style&index=0&id=5809488b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5809488b",
  null
  
)

export default component.exports